// Japanese (ja)
export default {
  // --- Shell / nav ---
  app_name: 'タイドナビ',
  search_stations: 'ステーションを検索',
  search_stations_hint: 'ステーションを検索 (⌘K)',
  settings: '設定',
  app_store: 'App Store でダウンロード',
  google_play: 'Google Play で手に入れよう',
  app_promo_title: '無料アプリをダウンロード。もっと速い 🙂',
  app_promo_body: '同じ潮汐・潮流予測を、スマートフォンで。',
  privacy: 'プライバシー',
  terms: '利用規約',
  data_sources: 'データソース',
  support: 'サポート',

  guides: 'ガイド',
  // --- Home ---
  home_title: '近くの潮汐と潮汐流を探す',
  by_country: '国別',
  favorite_tides: 'お気に入りの潮汐',
  recent_tides: '最近の潮汐',
  nearby_tides: '近くの潮汐',
  favorite_currents: 'お気に入りの潮汐流',
  recent_currents: '最近の潮汐流',
  nearby_currents: '近くの潮汐流',
  favorite_charts: 'お気に入りの海図',
  recent_charts: '最近の海図',
  nearby_charts: '近くの海図',
  finding_stations: '近くの観測所を検索中…',
  distance_away: '{{distance}} 先',

  // --- Search overlay ---
  search_placeholder: 'ステーションを検索…',
  tide_stations: '検潮所',
  current_stations: '検潮所（潮汐流）',
  recents: '最近',
  search_unavailable: '現在検索を利用できません。',
  no_stations_found: '観測所が見つかりません。',
  search_prompt: '潮汐・潮汐流の観測所を名前で検索します。',

  // --- Settings ---
  appearance: '外観',
  appearance_system: 'システム',
  appearance_light: 'ライト',
  appearance_dark: 'ダーク',
  tide_height: '潮位',
  unit_feet: 'フィート',
  unit_meters: 'メートル',
  distance: '距離',
  unit_miles: 'マイル',
  unit_kilometers: 'キロメートル',
  recent_stations: '最近の観測所',
  clear_recents: '最近の項目をクリア',
  currents: '潮汐流',
  nautical_charts: '海図',
  browse_by_country: '国別に見る',
  countries_auto: '自動',
  countries_always: '常に表示',
  countries_never: '表示しない',
  show: '表示',
  hide: '非表示',

  // --- Station pages (tide + current) ---
  tide_title: '{{name}}の潮汐',
  current_title: '{{name}}の潮汐流',
  last_tide: '前回の潮汐',
  next_tide: '次の潮汐',
  coefficient: 'Coef',
  last_current: '前回の潮汐流',
  next_current: '次の潮汐流',
  following_current: 'さらに次の潮汐流',
  high: '高',
  low: '低',
  tides: '潮汐',
  sun: '日',
  moon: '月',
  sunrise_now: '日の出',
  sunset_now: '日の入り',
  moonrise_now: '月の出',
  moonset_now: '月の入り',
  sunrise_week: '日の出',
  sunset_week: '日の入り',
  moonrise_week: '月の出',
  moonset_week: '月の入り',
  add_to_favorites: 'お気に入りに追加',
  remove_from_favorites: 'お気に入りから削除',

  // --- Week table dates ---
  today: '今日',
  tomorrow: '明日',

  // --- Moon phases ---
  phase_new_moon: '新月',
  phase_waxing_crescent: '三日月',
  phase_first_quarter: '上弦の月',
  phase_waxing_gibbous: '十三夜月',
  phase_full_moon: '満月',
  phase_waning_gibbous: '寝待月',
  phase_last_quarter: '下弦の月',
  phase_waning_crescent: '有明月',

  // --- Tide / current status vocabulary ---
  rising: '上昇中',
  falling: '下降中',
  high_tide: '満潮',
  low_tide: '干潮',
  ebb: '引き潮',
  flood: '上げ潮',
  slack: '停潮',

  // --- Relative time ---
  just_now: '今現在',
  somethings_wrong: 'エラーが発生しました',
  hour_ago: '{{hour}}時間前',
  hours_ago: '{{hour}}時間前',
  minute_ago: '{{minute}}分前',
  minutes_ago: '{{minute}}分前',
  hour_minute_ago: '{{hour}}時間{{minute}}分前',
  hour_minutes_ago: '{{hour}}時間{{minute}}分前',
  hours_minute_ago: '{{hour}}時間{{minute}}分前',
  hours_minutes_ago: '{{hour}}時間{{minute}}分前',
  hour_from_now: '今から{{hour}}時間後',
  hours_from_now: '今から{{hour}}時間後',
  minute_from_now: '今から{{minute}}分後',
  minutes_from_now: '今から{{minute}}分後',
  hour_minute_from_now: '今から{{hour}}時間{{minute}}分後',
  hour_minutes_from_now: '今から{{hour}}時間{{minute}}分後',
  hours_minute_from_now: '今から{{hour}}時間{{minute}}分後',
  hours_minutes_from_now: '今から{{hour}}時間{{minute}}分後',

  // --- Insights ---
  insights_7_day_overview: '7日間のインサイト',
  no_insights_available: 'この観測所のインサイトはありません。',
  insights_current_extremes: '潮流の極値',
  insights_fastest_flood: '最速上げ潮',
  insights_fastest_ebb: '最速下げ潮',
  insights_strongest_daily_currents: '日別ピーク潮流',
  insights_fastest_current: '最速',
  insights_slowest_current: '最遅',
  insights_tidal_extremes: '潮位の極値',
  insights_highest_tide: '最高潮位',
  insights_lowest_tide: '最低潮位',
  insights_strongest_daily_movements: '最大の潮位差',
  insights_largest_tide: '最大',
  insights_smallest_tide: '最小',
  insights_value_at_time: '{{time}}に{{value}}',
  insights_tidal_range_label: '潮位差',
  insights_max_current_label: '最大潮流',

  // --- Insight bands ---
  band_smaller_than_usual: '通常より小さい',
  band_typical: '通常',
  band_larger_than_usual: '通常より大きい',
  band_unusually_large: '異常に大きい',
  band_lower_than_usual: '通常より低い',
  band_unusually_low: '異常に低い',
  band_slower_than_usual: '通常より遅い',
  band_faster_than_usual: '通常より速い',
  band_unusually_fast: '異常に速い',
  band_smaller_than_usual_height: '通常より低い',
  band_larger_than_usual_height: '通常より高い',
  band_unusually_large_height: '異常に高い',

  // --- Map attribution ---
  attribution: '帰属表示',
  attribution_osm: '地図データ © OpenStreetMap 寄稿者',
  attribution_tiles: '地図タイル提供 OpenFreeMap',
  attribution_style: '地図スタイル © OpenMapTiles',
  ok: 'OK',

  // --- Explore map ---
  current_speed: '潮流の速さ',
  depth: '水深',
  speed: '速度',
  depth_datum: '基準面:',
  depth_drying: '干出',
  depth_loading: '水深データを読み込み中…',
  depth_datum_tag: '{{datum}} からの水深（{{unit}}）',
  depth_not_for_navigation: '航海用ではありません。',
  depth_unavailable: '水深データは現在利用できません。',
  depth_unit_m: 'm',
  depth_unit_ft: 'ft',
  go_mode_start: 'GO',
  go_mode_start_label: 'Go モードを開始',
  go_mode_exit: 'Go モードを終了',
  go_mode_location_denied: 'Go モードには位置情報が必要です。鍵アイコンから有効にしてください。',
  go_mode_location_denied_ok: 'OK',
  radar: 'レーダー',
  radar_precipitation: '降水',
  radar_light: '弱い',
  radar_moderate: 'やや強い',
  radar_heavy: '強い',
  radar_storm: '非常に強い',
  radar_forecast: '予測',
  radar_none_for_time: 'この時刻のレーダーはありません',
  now: '現在',
  explore_prompt_denied:
    'このサイトでは位置情報が無効になっています。アドレスバーの鍵アイコンから有効にしてください。',
  open_full_map: '全画面マップを開く',
  close_full_map: '全画面マップを閉じる',
  explore_full_map: '全画面マップを見る',
  center_on_location: '現在地を中央に表示',
  show_my_location: '現在地を表示',
  map_knots_label: '{{speed}} kt',

  // --- Location pages ---
  states: '州',
  no_stations_found_location: '観測所が見つかりません。',
  tides_and_currents_by_country: '国別の潮汐と潮汐流',

  // --- SEO titles / descriptions ---
  settings_seo_description: '潮位と距離の単位を選択します。',
  tide_seo_description: '{{name}}{{location}}の潮汐予報、満潮・干潮の時刻。',
  current_seo_description: '{{name}}{{location}}の潮汐流予報、上げ潮・引き潮の時刻。',
  location_title: '{{name}}の潮汐と潮汐流',
  country_seo_description:
    '{{name}}の潮汐時刻と潮汐流予報。{{name}}全域の{{stateTerm}}と沿岸の検潮所を見る。',
  state_seo_description:
    '{{country}}、{{name}}の潮汐・潮汐流予報。{{name}}の沿岸観測所の満潮・干潮の時刻。',
  city_seo_description: '{{place}}の潮汐時刻と潮汐流予報。{{name}}近くの満潮・干潮と潮汐流。',
  // --- Chart pages (chart titles, numbers and purposes stay in the
  // issuing authority's language: they name a specific printed sheet) ---
  charts_for_station: '{{name}}の海図',
  chart_intro:
    '{{title}}の無料海図。水深、ブイ、立標、岩、沈船、マリーナ、錨地、潮汐観測点を表示します。',
  chart_page_name: '{{title}} 海図',
  chart_seo_description:
    '{{title}}の無料海図。水深、ブイ、立標、岩、沈船、マリーナ、錨地、潮汐観測点を表示します。',

  countries_seo_title: '国別の検潮所・潮汐流観測所',
  countries_seo_description:
    '国別に潮汐・潮汐流の観測所を見る。世界中の沿岸地点の満潮・干潮の時刻と潮汐流予報。',
  home_seo_description:
    '近くの沿岸検潮所の潮汐時刻と潮汐流予報を確認できます。現在地の満潮・干潮を見たり、国別に検潮所を探したりできます。',
  explore_play: '再生',
  explore_pause: '一時停止',
  explore_playback_speed: '再生速度',
  explore_time: '時刻',
  skip_to_content: 'メインコンテンツにスキップ',
  // --- Weather (station pages) ---
  weather: '海上気象',
  wind: '風',
  gusts: '突風',
  seas: '波',
  time: '時刻',
  air_temp: '気温',
  water_temp: '水温',
  water_temperature: '水温',
  humidity: '湿度',
  pressure: '気圧',
  precip_chance: '降水確率',
  chances: '確率',
  precip_rate: '降水強度',
  visibility: '視程',
  condition_thunderstorms: '雷雨',
  condition_freezing_rain: '着氷性の雨',
  condition_sleet: 'みぞれ',
  condition_snow: '雪',
  condition_fog: '霧',
  condition_rain: '雨',
  condition_cloudy: '曇り',
  condition_partly_cloudy: '晴れ時々曇り',
  condition_clear: '晴れ',
  weather_thunder: '雷',
  note_seas_computed_from_wind: '波の高さは風と海岸線から推定されています。',
  note_seas_from_nearby_open_water: '波の状態は近くの外海のデータです。',
  note_seas_open_water_nearby:
    '近くの開けた海域の波は約{{height}}です。ここはそれより穏やかな場合があります。',
  note_seas_open_water_distant:
    '{{distance}}先の開けた海域の波は約{{height}}です。ここはそれより穏やかな場合があります。',
  note_seas_open_water_distant_dir:
    '{{direction}}方向に{{distance}}離れた開けた海域の波は約{{height}}です。ここはそれより穏やかな場合があります。',
  note_seas_unavailable: 'この地点の信頼できる波情報はありません。',
  note_sheltered_water_sees_less:
    '内湾など遮蔽された水域では、外海の値より穏やかになるのが普通です。',
  note_no_warning_feed_coverage: 'この地点をカバーする公式の海上警報はありません。',
  note_nearest_point_across_land: '最寄りの予報地点は陸地を挟んだ場所にあります。',
  warnings_none_active: '発効中の海上警報はありません',
  warnings_unavailable: 'この場所では海上警報を利用できません',
  warning_show_text: '公式文を表示',
  warning_hide_text: '公式文を隠す',
  weather_updated: '{{time}} 更新',
  current_conditions: '現在の状況',
  daily_forecast: '日別予報',
  expand_for_hourly: '展開して時間別を表示',
  hourly: '時間別',
  hourly_forecast: '時間別予報',
  wind_speed: '風速',
  wind_gusts: '風と突風',
  pressure_humidity: '気圧と湿度',
  max_seas: '最大波高',
  visibility_excellent: '非常に良い',
  visibility_good: '良好',
  visibility_moderate: '普通',
  visibility_poor: '不良',
  forecaster_text_link: '{{issuer}} の予報文',
  temperature: '温度',
  unit_fahrenheit: '華氏 (°F)',
  unit_celsius: '摂氏 (°C)',
  // --- Conditions summary (station pages) ---
  // Sea state: WMO Sea State Code. Wind: Beaufort. Both are published
  // scales with standard terminology in each language, not our own wording.
  // Warning-window and low–high range punctuation. CJK marks a range (and
  // an open end) with ～, not an en dash or a trailing plus.
  warning_window_range: '{{start}}～{{end}}',
  warning_window_open: '{{start}}～',
  range_separator_short: '～',
  // Wave-period fragments. The connector is the locale's own word for the
  // "at" in "0.5 m S @ 3s" (CJK says "period" instead); the value carries
  // the locale's seconds notation (秒/초 — bare Latin "s" reads as an
  // untranslated fragment in CJK weather products).
  seas_period_at: '周期',
  wave_period_short: '{{period}}秒',
  // 16-point compass, per this locale’s meteorological convention — the
  // letters differ across languages (Z/O/Ø/V…) and CJK writes the words out.
  compass_N: '北',
  compass_NNE: '北北東',
  compass_NE: '北東',
  compass_ENE: '東北東',
  compass_E: '東',
  compass_ESE: '東南東',
  compass_SE: '南東',
  compass_SSE: '南南東',
  compass_S: '南',
  compass_SSW: '南南西',
  compass_SW: '南西',
  compass_WSW: '西南西',
  compass_W: '西',
  compass_WNW: '西北西',
  compass_NW: '北西',
  compass_NNW: '北北西',
  // Known warning types, one badge label each. Bureau-home locales use the
  // bureau’s official terminology. Unknown types fall back to the humanized
  // English code in every locale (see warningTypeLabel).
  warning_type_small_craft_advisory: '小型船舶注意報',
  warning_type_gale_warning: '海上強風警報',
  warning_type_gale_watch: '強風早期注意情報',
  warning_type_storm_warning: '海上暴風警報',
  warning_type_storm_watch: '暴風早期注意情報',
  warning_type_hurricane_force_wind_warning: 'ハリケーン級暴風警報',
  warning_type_hurricane_force_wind_watch: 'ハリケーン級暴風早期注意情報',
  warning_type_special_marine_warning: '特別海上警報',
  warning_type_marine_weather_statement: '海上気象情報',
  warning_type_hazardous_seas_warning: '波浪警報',
  warning_type_brisk_wind_advisory: 'やや強い風注意報',
  warning_type_low_water_advisory: '低潮位注意報',
  warning_type_dense_fog_advisory: '濃霧注意報',
  warning_type_heavy_freezing_spray_warning: '強い飛沫着氷警報',
  warning_type_strong_wind_warning: '強風警報',
  warning_type_gale_force_wind_warning: '海上強風警報',
  warning_type_storm_force_wind_warning: '海上暴風警報',
  warning_type_wind_warning: '海上風警報',
  warning_type_dense_fog_warning: '海上濃霧警報',
  warning_type_icing_warning: '海上着氷警報',
  warning_type_typhoon_warning: '海上台風警報',
  warning_type_wind_wave_warning: '波浪警報',
  warning_type_wind_wave_advisory: '波浪注意報',
  warning_type_strong_wind_advisory: '強風注意報',
  warning_type_storm_surge_warning: '高潮警報',
  warning_type_storm_surge_advisory: '高潮注意報',
  warning_type_thunderstorm_warning: '雷警報',
  warning_type_rough_sea_warning: '波浪警報',
  warning_type_fog_warning: '濃霧警報',
  sea_state_calm_rippled: 'さざ波',
  sea_state_smooth: '穏やかな海面',
  sea_state_slight: 'やや波あり',
  sea_state_moderate: '波あり',
  sea_state_rough: '荒れた海面',
  sea_state_very_rough: '非常に荒れた海面',
  sea_state_high: '高波',
  sea_state_very_high: '非常な高波',
  sea_state_phenomenal: '異常な高波',
  hazard_showers: 'にわか雨',
  hazard_reduced_visibility: '視程不良',
  hazard_haze: 'もや',
  hazard_waterspout: '竜巻（海上）',
  hazard_freezing_spray: '着氷性の波しぶき',
  hazard_ice: '着氷',
  marine_summary_sea_wind: '{{sea}}、{{direction}}の風 {{speed}}。',
  marine_summary_wind_only_gusting: '{{direction}}の風 {{speed}}、最大瞬間 {{gust}}。',
  marine_summary_sea_wind_gusting: '{{sea}}、{{direction}}の風 {{speed}}、最大瞬間 {{gust}}。',
  marine_summary_wind_only: '{{direction}}の風 {{speed}}。',
  marine_summary_sea_only: '{{sea}}。',
  marine_prediction_caveat_tide_one:
    '潮汐予測は天文潮のみのため、その警報の気象により実際の潮位は高くも低くもなります。',
  marine_prediction_caveat_tide_many:
    '潮汐予測は天文潮のみのため、これらの警報の気象により実際の潮位は高くも低くもなります。',
  marine_prediction_caveat_current_one:
    '潮流予測は天文潮のみのため、その警報の気象により実際の流れは強くも弱くもなります。',
  marine_prediction_caveat_current_many:
    '潮流予測は天文潮のみのため、これらの警報の気象により実際の流れは強くも弱くもなります。',
  marine_warning_active: 'この海域に海上警報が発表されています。',
  marine_warnings_active: 'この海域に海上警報が発表されています。',
  marine_warning_upcoming: 'この海域には{{time}}から海上警報が発表されます。',
  marine_warnings_upcoming: 'この海域には{{time}}から海上警報が発表されます。',
  marine_summary_hazard_now: '現在{{hazard}}。',
  marine_summary_hazard_later: '予報では{{hazard}}。',
  marine_tide_rising: '潮位は{{height}}で上げ潮：次の満潮は{{time}}に{{next}}。',
  marine_tide_falling: '潮位は{{height}}で下げ潮：次の干潮は{{time}}に{{next}}。',
  marine_current_flood: '次の上げ潮流は{{time}}に{{speed}}。',
  marine_current_ebb: '次の下げ潮流は{{time}}に{{speed}}。',
  marine_current_slack: '次の憩流は{{time}}。',
  marine_current_now_flood: '上げ潮流{{speed}}。',
  marine_current_now_ebb: '下げ潮流{{speed}}。',
  marine_current_now_slack: '憩流。',
  marine_current_peak: '最強は{{time}}に{{speed}}。',

  // --- Chart furniture (navaid / hazard / POI click popups) ---
  // See en.js for the rules these follow. "IALA A" / "IALA B" stay untranslated
  // in every language: it is the standard's name.
  furn_light: '灯火',
  furn_buoy: 'ブイ',
  furn_beacon: '立標',
  furn_wreck: '沈船',
  furn_rock: '岩',
  furn_obstruction: '障害物',
  furn_anchorage: '錨地',
  furn_tss: '分離通航方式',
  furn_routing: '航路指定',
  furn_title_buoy: '{{category}}ブイ',
  furn_title_beacon: '{{category}}立標',
  furn_cat_port: '左舷',
  furn_cat_starboard: '右舷',
  furn_cat_preferred_channel_port: '優先航路左舷',
  furn_cat_preferred_channel_starboard: '優先航路右舷',
  furn_cat_safe_water: '安全水域',
  furn_cat_isolated_danger: '孤立障害',
  furn_cat_north: '北方位',
  furn_cat_east: '東方位',
  furn_cat_south: '南方位',
  furn_cat_west: '西方位',
  furn_cat_special: '特殊',
  furn_cat_mooring: '係留',
  furn_cat_lateral: '側面',
  furn_characteristic: '灯質',
  furn_range: '光達距離',
  furn_height: '高さ',
  furn_colour: '色',
  furn_shape: '形状',
  furn_lights_on_mark: 'この標識の灯火',
  furn_topmark: '頭標',
  furn_class: '種別',
  furn_least_depth_over: '最浅水深',
  furn_depth_over: '上部水深',
  furn_state: '状態',
  furn_type: '種類',
  furn_range_value: '{{value}} M',
  furn_metres_value: '{{value}} m',
  furn_cable: '海底ケーブル',
  furn_pipeline: '海底パイプライン',
  furn_restricted_area: '制限区域',
  furn_restriction: '制限',
  furn_mpa: '海洋保護区',
  furn_protection: '保護レベル',
  furn_agency: '管理機関',
  furn_mpa_note: '保全のための指定であり、航行制限ではありません。',
  furn_sector: '分弧',
  furn_sector_value: '{{from}}° → {{to}}°',
  lightw_f: '{{colour}}の不動光。',
  lightw_fl: '{{period}}秒ごとに{{colour}}の閃光。',
  lightw_fl_group: '{{period}}秒ごとに{{colour}}の群閃光（{{count}}回）。',
  lightw_lfl: '{{period}}秒ごとに{{colour}}の長い閃光。',
  lightw_q: '{{colour}}の急閃光。',
  lightw_iso: '{{period}}秒周期で{{colour}}の明暗が等しい等明暗光。',
  lightw_oc: '{{period}}秒ごとに短く暗くなる{{colour}}の明暗光。',
  lightcolour_white: '白色',
  lightcolour_red: '紅色',
  lightcolour_green: '緑色',
  lightcolour_yellow: '黄色',
  furn_feet_charted_value: '{{feet}} ft（海図値 {{metres}} m）',
  furn_light_yes: 'あり',
  furn_shown_neutral: '{{colours}}（中間色で表示）',
  furn_note_light: '夜間の灯火の見え方。船乗りはこれで識別します。',
  furn_note_lateral_b_port: '海から入るときの航路の左側を示します（IALA B：緑の円筒形）。',
  furn_note_lateral_b_starboard:
    '海から入るときの航路の右側を示します（IALA B：入航時は赤を右に）。',
  furn_note_lateral_a_port: '海から入るときの航路の左舷側を示します（IALA A：左舷は赤）。',
  furn_note_lateral_a_starboard: '海から入るときの航路の右舷側を示します（IALA A：右舷は緑）。',
  furn_note_safe_water: '周囲すべてが可航水域で、通常は接岸目標または航路中央の標識です。',
  furn_note_isolated_danger: '周囲が可航水域の孤立した危険物の上に設置されています。',
  furn_note_cardinal_north: '方位標識：北側を通過してください。',
  furn_note_cardinal_east: '方位標識：東側を通過してください。',
  furn_note_cardinal_south: '方位標識：南側を通過してください。',
  furn_note_cardinal_west: '方位標識：西側を通過してください。',
  furn_note_special: '特殊標識（黄）：区域の境界、海底ケーブル、係留、レースなど。',
  furn_note_preferred_starboard: '分岐標識：優先水路は右舷側にあります。',
  furn_note_preferred_port: '分岐標識：優先水路は左舷側にあります。',
  furn_note_mooring: '係留ブイです。',
  furn_vessel: '船舶',
  furn_depth_quality: '水深の精度区分',
  furn_length: '長さ',
  furn_position_accuracy: '位置精度',
  furn_remarks: '備考',
  furn_circumstances: '状況',
  furn_status: '状態',
  furn_note_shom: 'フランス海洋情報部（Shom）による海図情報。©Shom, CC BY-SA 4.0.',
  furn_lock: '閘門',
  furn_bridge: '橋',
  furn_overhead_cable: '架空ケーブル',
  furn_notice_mark: '標識',
  furn_distance_mark: '距離標',
  furn_daymark: '昼標',
  furn_channel: '水路',
  furn_vertical_clearance_closed: '桁下高（閉）',
  furn_vertical_clearance_open: '桁下高（開）',
  furn_datum: '基準面',
  furn_datum_value: '{plane} (VERDAT {code})',
  furn_datum_unknown: 'unknown code (VERDAT {code})',
  furn_note_ienc:
    '内陸ENC（米国陸軍工兵隊）。桁下高は上記の基準面からの高さです。増水時の実際の空間高はこれより小さくなります。',
  furn_note_wreck: '海図に記載された沈船です。水深は海図の値で、検証されていません。',
  furn_note_anchorage: '海図に記載された錨地です。',
  furn_note_tss: '一方通行の航路帯です。小型船は直角に横断し、航路を避けてください。',
  furn_route: '航路',
  furn_fairway: '可航水路',
  furn_recommended_track: '推薦航路',
  furn_navigation_line: '航行線',
  furn_leading_line: '導線',
  furn_clearing_line: '安全限界線',
  furn_transit_line: '通航線',
  furn_traffic: '通航',
  furn_orientation: '方位',
  furn_degrees_value: '{{value}}°',
  furn_note_fairway: '海図に記載された可航水路です。維持または推奨される水路を示します。',
  furn_note_track: '海図に記載された航路線です。',
  furn_note_track_fixed_marks: '海図に記載された航路線です。固定標識（重視線）に基づきます。',
  furn_note_leading_line: '導標を重ねたまま進むと、海図の線上を保てます。',
  furn_note_navigation_line: '海図に記載された航行線です。',
  furn_poi_marina: 'マリーナ',
  furn_poi_fuel: '給油',
  furn_poi_slipway: 'スロープ',
  furn_poi_ferry_terminal: 'フェリーターミナル',
  furn_poi_boatyard: '造船所',
  furn_poi_lighthouse: '灯台',
  furn_note_slipway: '進水スロープです。',
  // Layers sheet — UNTRANSLATED, English placeholders (2026-09-11). Catalog
  // parity is enforced by scripts/check-locale-keys.mjs, so a key cannot be
  // added to en.js alone; these are placeholders awaiting translation, not
  // a claim that the strings are localized.
  layers: 'Layers',
  layers_close: 'Close layers',
  layers_map_type: 'Map type',
  layers_visualizations: 'Visualizations',
  layers_standard_map: 'Standard Map',
  layers_depth_chart: 'Depth Chart',
  layers_moving_tides: 'Moving Tides',
  layers_moving_currents: 'Moving Currents',
  layers_wind_waves: 'Wind & Waves',
  layers_weather_radar: 'Weather Radar',
  layers_coming_soon: 'Coming soon',
  layers_no_currents_here: 'No current stations in view',
  layers_no_radar_here: 'No radar coverage in view',
  // The compass button's accessible name. {{point}} is a 16-point direction
  // (SSW) and {{deg}} the exact bearing — the face rounds to 8 points, this
  // does not. English placeholder in the non-English catalogs, awaiting
  // translation; catalog parity is enforced by scripts/check-locale-keys.mjs.
  follow_my_direction: '自分の向きに合わせる',
  compass_faces: 'Map faces {{point}} · {{deg}}°, tap for north-up',
  ww_row_no_data: '{{row}}: この地点のデータはありません',
  ww_row_no_forecast_after: '{{row}}: {{when}}以降の予報はありません',
  ww_row_no_forecast: '{{row}}: これより先の予報はありません',
  ww_unavailable: '天気情報を利用できません',
  explore_show_player: 'タイムラインを表示',
  explore_hide_player: 'タイムラインを非表示',

  // ROUTE PLANNING on /explore (2026-10-23). Describe, never advise; never
  // "safe". route_disclaimer is only the fallback when the service's response
  // carries no disclaimer of its own.
  route_plan: 'ルートを計画',
  route_leave: 'ルート計画を終了',
  route_title: 'ルート',
  route_prompt_start: '出発する水面をタップしてください。',
  route_prompt_start_desktop: '出発する水面をクリックし、次に目的地をクリックしてください。',
  route_prompt_end: '出発地を設定しました。次に目的地をタップしてください。',
  route_prompt_end_desktop: '出発地を設定しました。次に目的地をクリックしてください。',
  route_drag_hint: 'ピンはドラッグで動かせます。',
  route_clear: 'クリア',
  route_swap: '出発地と目的地を入れ替え',
  route_share: 'リンクをコピー',
  route_copied: 'リンクをコピーしました',
  route_start: '出発地',
  route_destination: '目的地',
  route_near: '{{name}}付近',
  route_loading: 'ルートを作成中…',
  route_loading_sub: '通常は1〜2秒です。海域によっては最大30秒かかります。',
  route_loading_slow: '処理中です…',
  route_loading_slow_sub: 'この海域はいつもより時間がかかっています。',
  route_summary_time: '{{duration}}（{{speed}}）',
  route_planning_speed: '計画速力',
  route_shoalest: 'ルート上の最浅部',
  route_planning_draft: '計画喫水',
  route_change: '変更',
  route_draft_title: '計画喫水',
  route_draft_help:
    'ルートを計画する際の水深で、お使いの船の喫水ではありません。深くすると経路が少なくなり、浅くすると多くなります。',
  route_datum: '水深は海図基準面（MLLW）での値で、潮位は反映していません。',
  route_unassured_note:
    'オレンジ色の区間は、海図と測量では{{draft}}未満の水深を判別できない水域を通ります。',
  route_row_start: '出発 {{label}}',
  route_row_heading: '針路 {{course}}°（{{point}}）',
  route_row_end: '到着 {{label}}',
  route_row_end_sub: 'ルート終点',
  route_turn_left: '左に変針し {{course}}° へ',
  route_turn_right: '右に変針し {{course}}° へ',
  route_bear_left: 'やや左へ {{course}}°',
  route_bear_right: 'やや右へ {{course}}°',
  route_then: '{{first}}、続いて{{second}}',
  route_keep_mark: '{{mark}}を{{hand}}に見て進む',
  route_leave_channel: '{{mark}}で水路を出る',
  route_on_your: '{{hand}}側（{{side}}）',
  route_hand_left: '左',
  route_hand_right: '右',
  route_side_port: '左舷',
  route_side_starboard: '右舷',
  route_mark_buoy: '{{color}}ブイ {{num}}',
  route_mark_light: '{{color}}灯標 {{num}}',
  route_mark_daybeacon: '{{color}}立標 {{num}}',
  route_mark_lighted: '{{mark}}（灯火付き）',
  route_red: '赤',
  route_green: '緑',
  route_follow: '{{name}}に沿って進む',
  route_follow_two: '{{first}}、続いて{{second}}に沿って進む',
  route_follow_channel: '{{name}}水路',
  route_follow_named: '{{name}}',
  route_follow_unnamed: '標識のある水路',
  route_follow_marks: '標識{{count}}基',
  route_greens_on: '緑の標識は{{hand}}',
  route_reds_on: '赤の標識は{{hand}}',
  route_show_marks: '標識を表示',
  route_hide_marks: '標識を非表示',
  route_why: 'ここで変針する理由は？',
  route_turn_reason: 'ここで変針する理由：{{reason}}',
  route_lights: '光達範囲内の灯火：{{lights}}',
  route_stretch_unassured: '{{draft}}未満の水深は判別できません',
  route_stretch_rocky: '海図記載の岩の間',
  route_stretch_canal: '運河：閘門の運用、ゲート、橋の桁下高は考慮していません',
  route_step_of: 'ステップ {{n}}/{{total}}',
  route_all_steps: 'すべてのステップ',
  route_prev_step: '前のステップ',
  route_next_step: '次のステップ',
  route_minutes: '{{n}}分',
  route_hours: '{{h}}時間',
  route_hours_minutes: '{{h}}時間{{m}}分',
  route_err_on_land_origin: '出発地が海図上の陸地にあります',
  route_err_on_land_destination: '目的地が海図上の陸地にあります',
  route_err_on_land_origin_sub:
    '出発地のピンを水面へドラッグしてください。湿地、砂浜、桟橋は海図上では陸地として扱われます。',
  route_err_on_land_destination_sub:
    '目的地のピンを水面へドラッグしてください。湿地、砂浜、桟橋は海図上では陸地として扱われます。',
  route_err_no_route: '計画喫水{{draft}}ではルートが見つかりません',
  route_err_no_route_sub:
    '2点の間のどこかで、海図の水深が{{draft}}より浅くなっています。計画喫水を小さくすると経路が見つかる場合があります。',
  route_err_no_snap: 'いずれかの地点の近くに海図上の水域がありません',
  route_err_no_snap_sub: 'ピンを開けた水域の近くへ移動してください。',
  route_err_outside: 'ルート計画は現在、米国の水域のみ対応しています',
  route_err_outside_sub:
    'ルートはNOAAの海図から作成するため、両方の地点が米国の水域にある必要があります。ほかの沿岸にも今後対応します。',
  route_err_timeout: 'ルートサービスの応答に時間がかかりすぎました',
  route_err_timeout_sub: '海域によっては最大30秒かかり、今回は時間切れになりました。',
  route_err_unavailable: 'ルート計画は現在ご利用いただけません',
  route_err_unavailable_sub: 'しばらくしてからもう一度お試しください。',
  route_err_busy: 'ルートのリクエストが多すぎます',
  route_err_busy_sub: '1分ほど待ってから、もう一度お試しください。',
  route_try_again: 'もう一度試す',
  route_disclaimer:
    '航海用ではありません。このルートは海図に記載された標識のある水路に沿っていますが、安全な水域であることを示すものではありません。',
  route_promo_title: 'Go Modeでこのルートをアプリでたどる',
  route_promo_body:
    'Go Modeでは、次の標識や変針点までの距離、船の下の水深、最寄りの観測所の潮汐と潮汐流とともに、海図上で自船の位置を表示し続けます。iPhone・Android版のタイドナビで、サブスクリプションにてご利用いただけます。',
}
